<template>
  <v-form @submit.prevent="savePermissions">
    <v-card>
      <v-row class="px-4">
        <v-col sm="6">
          <label class="custom-label">Role</label>
          <v-select v-model="selectedRole" @input="getPermissions" :items="roles" label="Choose User"
            placeholder="Choose User" solo></v-select>
        </v-col>
        <v-col sm="6">
          <div class="d-flex justify-end">
            <v-btn :loading="loading" color="primary" class="mt-6" @click="savePermissions">Save Permissions</v-btn>
          </div>
        </v-col>
      </v-row>
      <v-data-table :page.sync="page" @page-count="pageCount = $event" :items="paths" :headers="headers"
        hide-default-footer>
        <template v-slot:item.modules="{ item }">{{ item.modules }}</template>
        <template v-slot:item.permissions="{ item }">
          <v-box v-for="(item) in item.permissions" :key="item">
            <v-row>
              <!-- Show -->
              <v-col sm="2"
                v-if="item.show === 0 || item.show === 1 || item.show === null || item.show === true || item.show === false">
                <v-checkbox :value="item.show" v-model="item.show" :label="`Show`" color="#0EBDDFF7"></v-checkbox>
              </v-col>


              <v-col sm="2"
                v-if="item.work_add === 0 || item.work_add === 1 || item.work_add === null || item.work_add === true || item.work_add === false">
                <v-checkbox :value="item.work_add" v-model="item.work_add" :label="`Add`" color="#0EBDDFF7">
                </v-checkbox>
              </v-col>

              <v-col sm="2"
                v-if="item.work_edit === 0 || item.work_edit === 1 || item.work_edit === null || item.work_edit === true || item.work_edit === false">
                <v-checkbox :value="item.work_edit" v-model="item.work_edit" :label="`Edit`" color="#0EBDDFF7">
                </v-checkbox>
              </v-col>

              <v-col sm="2"
                v-if="item.work_delete === 0 || item.work_delete === 1 || item.work_delete === null || item.work_delete === true || item.work_delete === false">
                <v-checkbox :value="item.work_delete" v-model="item.work_delete" :label="`Delete`" color="#0EBDDFF7">
                </v-checkbox>
              </v-col>



              <!-- Enquiry -->

              <!-- <v-col
                sm="2"
                v-if="item.enquiry === 0 || item.enquiry === 1 || item.enquiry === null || item.enquiry === true || item.enquiry === false"
              >
                <v-checkbox
                  :value="item.enquiry"
                  v-model="item.enquiry"
                  :label="`Enquiry`"
                  color="#0EBDDFF7"
                ></v-checkbox>
              </v-col>-->

              <!-- Joined -->

              <!-- <v-col
                sm="2"
                v-if="item.joined === 0 || item.joined === 1 || item.joined === null || item.joined === true || item.joined === false"
              >
                <v-checkbox
                  :value="item.joined"
                  v-model="item.joined"
                  :label="`Joined`"
                  color="#0EBDDFF7"
                ></v-checkbox>
              </v-col>-->

              <!-- Group Permissions -->
              <v-col sm="2"
                v-if="item.g_delete === 0 || item.g_add === 1 || item.g_add === null || item.g_add === true || item.g_add === false">
                <v-checkbox :value="item.g_add" v-model="item.g_add" :label="`Add`" color="#0EBDDFF7"></v-checkbox>
              </v-col>

              <v-col sm="2"
                v-if="item.g_edit === 0 || item.g_edit === 1 || item.g_edit === null || item.g_edit === true || item.g_edit === false">
                <v-checkbox :value="item.g_edit" v-model="item.g_edit" :label="`Edit`" color="#0EBDDFF7"></v-checkbox>
              </v-col>

              <v-col sm="2"
                v-if="item.g_delete === 0 || item.g_delete === 1 || item.g_delete === null || item.g_delete === true || item.g_delete === false">
                <v-checkbox :value="item.g_delete" v-model="item.g_delete" :label="`Delete`" color="#0EBDDFF7">
                </v-checkbox>
              </v-col>


              <!-- End Group permissions -->

              <!-- Joined students -->
              <v-col sm="2"
                v-if="item.joinedStudents === 0 || item.joinedStudents === 1 || item.joinedStudents === null || item.joinedStudents === true || item.joinedStudents === false">
                <v-checkbox :value="item.joinedStudents" v-model="item.joinedStudents" :label="`Joined Students`"
                  color="#0EBDDFF7"></v-checkbox>
              </v-col>
              <!-- Joined Tutors -->
              <v-col sm="2"
                v-if="item.joinedTutors === 0 || item.joinedTutors === 1 || item.joinedTutors === null || item.joinedTutors === true || item.joinedTutors === false">
                <v-checkbox :value="item.joinedTutors" v-model="item.joinedTutors" :label="`Joined Tutors`"
                  color="#0EBDDFF7"></v-checkbox>
              </v-col>
              <!-- receive call data -->
              <v-col sm="2"
                v-if="item.receiveCallData === 0 || item.receiveCallData === 1 || item.receiveCallData === null || item.receiveCallData === true || item.receiveCallData === false">
                <v-checkbox :value="item.receiveCallData" v-model="item.receiveCallData" :label="`Receive Call Data`"
                  color="#0EBDDFF7"></v-checkbox>
              </v-col>
              <!-- Tutor cv -->
              <v-col sm="2"
                v-if="item.tutorCV === 0 || item.tutorCV === 1 || item.tutorCV === null || item.tutorCV === true || item.tutorCV === false">
                <v-checkbox :value="item.tutorCV" v-model="item.tutorCV" :label="`Tutor CV`" color="#0EBDDFF7">
                </v-checkbox>
              </v-col>
              <!-- Record Managment Edit -->
              <v-col sm="2"
                v-if="item.r_edit === 0 || item.r_edit === 1 || item.r_edit === null || item.r_edit === true || item.r_edit === false">
                <v-checkbox :value="item.r_edit" v-model="item.r_edit" :label="`Edit`" color="#0EBDDFF7"></v-checkbox>
              </v-col>

              <!-- Record Managment Delete -->

              <v-col sm="2"
                v-if="item.r_delete === 0 || item.r_delete === 1 || item.r_delete === null || item.r_delete === true || item.r_delete === false">
                <v-checkbox :value="item.r_delete" v-model="item.r_delete" :label="`Delete`" color="#0EBDDFF7">
                </v-checkbox>
              </v-col>
              <!-- cathups -->
              <v-col sm="2"
                v-if="item.catchups === 0 || item.catchups === 1 || item.catchups === null || item.catchups === true || item.catchups === false">
                <v-checkbox :value="item.catchups" v-model="item.catchups" :label="`CatchUps`" color="#0EBDDFF7">
                </v-checkbox>
              </v-col>
              <!-- requests -->
              <v-col sm="2"
                v-if="item.requests === 0 || item.requests === 1 || item.requests === null || item.requests === true || item.requests === false">
                <v-checkbox :value="item.requests" v-model="item.requests" :label="`Requests`" color="#0EBDDFF7">
                </v-checkbox>
              </v-col>
              <!-- absents -->
              <v-col sm="2"
                v-if="item.absents === 0 || item.absents === 1 || item.absents === null || item.absents === true || item.absents === false">
                <v-checkbox :value="item.absents" v-model="item.absents" :label="`Absents`" color="#0EBDDFF7">
                </v-checkbox>
              </v-col>
              <!-- complete -->
              <v-col sm="2"
                v-if="item.complete === 0 || item.complete === 1 || item.complete === null || item.complete === true || item.complete === false">
                <v-checkbox :value="item.complete" v-model="item.complete" :label="`Complete`" color="#0EBDDFF7">
                </v-checkbox>
              </v-col>

              <!-- Upload -->
              <v-col sm="2"
                v-if="item.upload === 0 || item.upload === 1 || item.upload === null || item.upload === true || item.upload === false">
                <v-checkbox :value="item.upload" v-model="item.upload" :label="`Upload`" color="#0EBDDFF7"></v-checkbox>
              </v-col>
              <!-- assign -->
              <v-col sm="2"
                v-if="item.assign === 0 || item.assign === 1 || item.assign === null || item.assign === true || item.assign === false">
                <v-checkbox :value="item.assign" v-model="item.assign" :label="`Assign`" color="#0EBDDFF7"></v-checkbox>
              </v-col>
              <!-- print -->
              <v-col sm="2"
                v-if="item.print === 0 || item.print === 1 || item.print === null || item.print === true || item.print === false">
                <v-checkbox :value="item.print" v-model="item.print" :label="`Print`" color="#0EBDDFF7"></v-checkbox>
              </v-col>
              <!-- chartView -->
              <v-col sm="2"
                v-if="item.chartView === 0 || item.chartView === 1 || item.chartView === null || item.chartView === true || item.chartView === false">
                <v-checkbox :value="item.chartView" v-model="item.chartView" :label="`Chart View`" color="#0EBDDFF7">
                </v-checkbox>
              </v-col>

              <!-- AnswerSheet -->
              <v-col sm="2"
                v-if="item.answerSheet === 0 || item.answerSheet === 1 || item.answerSheet === null || item.answerSheet === true || item.answerSheet === false">
                <v-checkbox :value="item.answerSheet" v-model="item.answerSheet" :label="`Answer Sheet`" color="#0EBDDFF7">
                </v-checkbox>
              </v-col>

              <!-- classes -->
              <v-col sm="2"
                v-if="item.classes === 0 || item.classes === 1 || item.classes === null || item.classes === true || item.classes === false">
                <v-checkbox :value="item.classes" v-model="item.classes" :label="`Classes`" color="#0EBDDFF7">
                </v-checkbox>
              </v-col>
              <!-- users -->
              <v-col sm="2"
                v-if="item.users === 0 || item.users === 1 || item.users === null || item.users === true || item.users === false">
                <v-checkbox :value="item.users" v-model="item.users" :label="`Users`" color="#0EBDDFF7"></v-checkbox>
              </v-col>
              <!-- discounts -->
              <v-col sm="2"
                v-if="item.discounts === 0 || item.discounts === 1 || item.discounts === null || item.discounts === true || item.discounts === false">
                <v-checkbox :value="item.discounts" v-model="item.discounts" :label="`Discounts`" color="#0EBDDFF7">
                </v-checkbox>
              </v-col>
              <!-- attendance -->
              <v-col sm="2"
                v-if="item.attendance === 0 || item.attendance === 1 || item.attendance === null || item.attendance === true || item.attendance === false">
                <v-checkbox :value="item.attendance" v-model="item.attendance" :label="`Attendance`" color="#0EBDDFF7">
                </v-checkbox>
              </v-col>
              <!-- upComingClasses -->
              <v-col sm="2"
                v-if="item.upComingClasses === 0 || item.upComingClasses === 1 || item.upComingClasses === null || item.upComingClasses === true || item.upComingClasses === false">
                <v-checkbox :value="item.upComingClasses" v-model="item.upComingClasses" :label="`Up Coming Classes`"
                  color="#0EBDDFF7"></v-checkbox>
              </v-col>
              <!-- completedClasses -->
              <v-col sm="2"
                v-if="item.completedClasses === 0 || item.completedClasses === 1 || item.completedClasses === null || item.completedClasses === true || item.completedClasses === false">
                <v-checkbox :value="item.completedClasses" v-model="item.completedClasses" :label="`Completed Classes`"
                  color="#0EBDDFF7"></v-checkbox>
              </v-col>
              <!-- paid -->
              <v-col sm="2"
                v-if="item.paid === 0 || item.paid === 1 || item.paid === null || item.paid === true || item.paid === false">
                <v-checkbox :value="item.paid" v-model="item.paid" :label="`Paid`" color="#0EBDDFF7"></v-checkbox>
              </v-col>
              <!-- unPain -->
              <v-col sm="2"
                v-if="item.unPain === 0 || item.unPain === 1 || item.unPain === null || item.unPain === true || item.unPain === false">
                <v-checkbox :value="item.unPain" v-model="item.unPain" :label="`Un Pain`" color="#0EBDDFF7">
                </v-checkbox>
              </v-col>
              <!-- uploadedWork -->
              
              <!-- <v-col sm="2"
                v-if="item.uploadedWork === 0 || item.uploadedWork === 1 || item.uploadedWork === null || item.uploadedWork === true || item.uploadedWork === false">
                <v-checkbox :value="item.uploadedWork" v-model="item.uploadedWork" :label="`Upload Work`"
                  color="#0EBDDFF7"></v-checkbox>
              </v-col> -->
              
              <!-- previousWork -->
              <v-col sm="2"
                v-if="item.previousWork === 0 || item.previousWork === 1 || item.previousWork === null || item.previousWork === true || item.previousWork === false">
                <v-checkbox :value="item.previousWork" v-model="item.previousWork" :label="`Previous Work`"
                  color="#0EBDDFF7"></v-checkbox>
              </v-col>
              <!-- pending -->
              <v-col sm="2"
                v-if="item.pending === 0 || item.pending === 1 || item.pending === null || item.pending === true || item.pending === false">
                <v-checkbox :value="item.pending" v-model="item.pending" :label="`Pending`" color="#0EBDDFF7">
                </v-checkbox>
              </v-col>
              <!-- cleared -->
              <v-col sm="2"
                v-if="item.cleared === 0 || item.cleared === 1 || item.cleared === null || item.cleared === true || item.cleared === false">
                <v-checkbox :value="item.cleared" v-model="item.cleared" :label="`Cleared`" color="#0EBDDFF7">
                </v-checkbox>
              </v-col>
            </v-row>
            <!-- Awais -->
            <v-row>
              <v-col sm="2"
                v-if="item.enquiry === 0 || item.enquiry === 1 || item.enquiry === null || item.enquiry === true || item.enquiry === false">
                <v-checkbox :value="item.enquiry" v-model="item.enquiry" :label="`Enquiry`" color="#0EBDDFF7">
                </v-checkbox>
              </v-col>
              <v-col sm="2"
                v-if="item.book_free_assesment === 0 || item.book_free_assesment === 1 || item.book_free_assesment === null || item.book_free_assesment === true || item.book_free_assesment === false">
                <v-checkbox :value="item.book_free_assesment" v-model="item.book_free_assesment"
                  :label="`Book Free Assessment`" color="#0EBDDFF7"></v-checkbox>
              </v-col>
              <v-col sm="2"
                v-if="item.add_to_joined === 0 || item.add_to_joined === 1 || item.add_to_joined === null || item.add_to_joined === true || item.add_to_joined === false">
                <v-checkbox :value="item.add_to_joined" v-model="item.add_to_joined" :label="`Add To Joined`"
                  color="#0EBDDFF7"></v-checkbox>
              </v-col>
              <v-col sm="2"
                v-if="item.enquiry_delete === 0 || item.enquiry_delete === 1 || item.enquiry_delete === null || item.enquiry_delete === true || item.enquiry_delete === false">
                <v-checkbox :value="item.enquiry_delete" v-model="item.enquiry_delete" :label="`Delete`"
                  color="#0EBDDFF7"></v-checkbox>
              </v-col>
            </v-row>

            <v-row>
              <v-col sm="2"
                v-if="item.joined === 0 || item.joined === 1 || item.joined === null || item.joined === true || item.joined === false">
                <v-checkbox :value="item.joined" v-model="item.joined" :label="`Joined`" color="#0EBDDFF7"></v-checkbox>
              </v-col>

              <v-col sm="2"
                v-if="item.joined_view === 0 || item.joined_view === 1 || item.joined_view === null || item.joined_view === true || item.joined_view === false">
                <v-checkbox :value="item.joined_view" v-model="item.joined_view" :label="`View`" color="#0EBDDFF7">
                </v-checkbox>
              </v-col>

              <v-col sm="2"
                v-if="item.joined_edit === 0 || item.joined_edit === 1 || item.joined_edit === null || item.joined_edit === true || item.joined_edit === false">
                <v-checkbox :value="item.joined_edit" v-model="item.joined_edit" :label="`Edit`" color="#0EBDDFF7">
                </v-checkbox>
              </v-col>
              <v-col sm="2"
                v-if="item.joined_delete === 0 || item.joined_delete === 1 || item.joined_delete === null || item.joined_delete === true || item.joined_delete === false">
                <v-checkbox :value="item.joined_delete" v-model="item.joined_delete" :label="`Delete`"
                  color="#0EBDDFF7"></v-checkbox>
              </v-col>
            </v-row>

            <v-row>
              <v-col sm="2"
                v-if="item.t_add === 0 || item.t_add === 1 || item.t_add === null || item.t_add === true || item.t_add === false">
                <v-checkbox :value="item.t_add" v-model="item.t_add" :label="`Add`" color="#0EBDDFF7"></v-checkbox>
              </v-col>

              <v-col sm="2"
                v-if="item.t_view === 0 || item.t_view === 1 || item.t_view === null || item.t_view === true || item.t_view === false">
                <v-checkbox :value="item.t_view" v-model="item.t_view" :label="`View Session`" color="#0EBDDFF7">
                </v-checkbox>
              </v-col>

              <v-col sm="2"
                v-if="item.t_edit === 0 || item.t_edit === 1 || item.t_edit === null || item.t_edit === true || item.t_edit === false">
                <v-checkbox :value="item.t_edit" v-model="item.t_edit" :label="`Edit`" color="#0EBDDFF7"></v-checkbox>
              </v-col>

              <v-col sm="2"
                v-if="item.t_delete === 0 || item.t_delete === 1 || item.t_delete === null || item.t_delete === true || item.t_delete === false">
                <v-checkbox :value="item.t_delete" v-model="item.t_delete" :label="`Delete`" color="#0EBDDFF7">
                </v-checkbox>
              </v-col>
            </v-row>
            <!-- end tutor session -->

            <!-- student profile -->
            <v-row>
              <v-col sm="2"
                v-if="item.add_stud === 0 || item.add_stud === 1 || item.add_stud === null || item.add_stud === true || item.add_stud === false">
                <v-checkbox :value="item.add_stud" v-model="item.add_stud" :label="`Add`" color="#0EBDDFF7">
                </v-checkbox>
              </v-col>
            </v-row>
            <!-- end student profile -->

            <!-- Account Module -->

            <v-row>

              <!-- Payment Row -->
              <v-col sm="2"
                v-if="item.payment === 0 || item.payment === 1 || item.payment === null || item.payment === true || item.payment === false">
                <v-checkbox :value="item.payment" v-model="item.payment" :label="`Payment`" color="#0EBDDFF7">
                </v-checkbox>
              </v-col>

              <!-- Send Invoice -->
              <v-col sm="2"
                v-if="item.pay_add === 0 || item.pay_add === 1 || item.pay_add === null || item.pay_add === true || item.pay_add === false">
                <v-checkbox :value="item.pay_add" v-model="item.pay_add" :label="`Add`" color="#0EBDDFF7"></v-checkbox>
              </v-col>

              <!-- Add -->
              <v-col sm="2"
                v-if="item.pay_view === 0 || item.pay_view === 1 || item.pay_view === null || item.pay_view === true || item.pay_view === false">
                <v-checkbox :value="item.pay_view" v-model="item.pay_view" :label="`View`" color="#0EBDDFF7">
                </v-checkbox>
              </v-col>

              <!-- status -->
              <v-col sm="2"
                v-if="item.pay_sendInvoice === 0 || item.pay_sendInvoice === 1 || item.pay_sendInvoice === null || item.pay_sendInvoice === true || item.pay_sendInvoice === false">
                <v-checkbox :value="item.pay_sendInvoice" v-model="item.pay_sendInvoice" :label="`Send Invoice`"
                  color="#0EBDDFF7"></v-checkbox>
              </v-col>

              <v-col sm="2"
                v-if="item.pay_status === 0 || item.pay_status === 1 || item.pay_status === null || item.pay_status === true || item.pay_status === false">
                <v-checkbox :value="item.pay_status" v-model="item.pay_status" :label="`Set Status`" color="#0EBDDFF7">
                </v-checkbox>
              </v-col>

              <v-col sm="2"
                v-if="item.pay_remove === 0 || item.pay_remove === 1 || item.pay_remove === null || item.pay_remove === true || item.pay_remove === false">
                <v-checkbox :value="item.pay_remove" v-model="item.pay_remove" :label="`Delete`" color="#0EBDDFF7">
                </v-checkbox>
              </v-col>

            </v-row>

            <v-row>
              <!-- Earning Row -->
              <v-col sm="2"
                v-if="item.earning === 0 || item.earning === 1 || item.earning === null || item.earning === true || item.earning === false">
                <v-checkbox :value="item.earning" v-model="item.earning" :label="`Earning`" color="#0EBDDFF7">
                </v-checkbox>
              </v-col>

              <v-col sm="2"
                v-if="item.earn_view === 0 || item.earn_view === 1 || item.earn_view === null || item.earn_view === true || item.earn_view === false">
                <v-checkbox :value="item.earn_view" v-model="item.earn_view" :label="`View`" color="#0EBDDFF7">
                </v-checkbox>
              </v-col>


            </v-row>

            <v-row>
              <!-- Bad Dept Row -->
              <v-col sm="2"
                v-if="item.badDept === 0 || item.badDept === 1 || item.badDept === null || item.badDept === true || item.badDept === false">
                <v-checkbox :value="item.badDept" v-model="item.badDept" :label="`Bad Dept`" color="#0EBDDFF7">
                </v-checkbox>
              </v-col>

            </v-row>

            <v-row>
              <!-- Tutor Earning Row -->
              <v-col sm="2"
                v-if="item.tutorEarning === 0 || item.tutorEarning === 1 || item.tutorEarning === null || item.tutorEarning === true || item.tutorEarning === false">
                <v-checkbox :value="item.tutorEarning" v-model="item.tutorEarning" :label="`Tutor Earning`"
                  color="#0EBDDFF7"></v-checkbox>
              </v-col>

              <!-- Add -->
              <v-col sm="2"
                v-if="item.tutor_earn_add === 0 || item.tutor_earn_add === 1 || item.tutor_earn_add === null || item.tutor_earn_add === true || item.tutor_earn_add === false">
                <v-checkbox :value="item.tutor_earn_add" v-model="item.tutor_earn_add" :label="`Add`" color="#0EBDDFF7">
                </v-checkbox>
              </v-col>

              <!-- Edit -->
              <v-col sm="2"
                v-if="item.tutor_earn_edit === 0 || item.tutor_earn_edit === 1 || item.tutor_earn_edit === null || item.tutor_earn_edit === true || item.tutor_earn_edit === false">
                <v-checkbox :value="item.tutor_earn_edit" v-model="item.tutor_earn_edit" :label="`Edit`"
                  color="#0EBDDFF7"></v-checkbox>
              </v-col>

              <!-- delete -->
              <v-col sm="2"
                v-if="item.tutor_earn_delete === 0 || item.tutor_earn_delete === 1 || item.tutor_earn_delete === null || item.tutor_earn_delete === true || item.tutor_earn_delete === false">
                <v-checkbox :value="item.tutor_earn_delete" v-model="item.tutor_earn_delete" :label="`Delete`"
                  color="#0EBDDFF7"></v-checkbox>
              </v-col>

            </v-row>

            <!-- End Awais -->
            <v-row>
              <!-- configrations -->
              <v-col sm="2" style="margin-top: -50px"
                v-if="item.configrations === 0 || item.configrations === 1 || item.configrations === null || item.configrations === true || item.configrations === false">
                <v-checkbox :value="item.configrations" v-model="item.configrations" :label="`Configrations`"
                  color="#0EBDDFF7"></v-checkbox>
              </v-col>
              <!-- roles -->
              <v-col sm="2" style="margin-top: -50px"
                v-if="item.roles === 0 || item.roles === 1 || item.roles === null || item.roles === true || item.roles === false">
                <v-checkbox :value="item.roles" v-model="item.roles" :label="`Roles`" color="#0EBDDFF7"></v-checkbox>
              </v-col>
              <!-- permissions -->
              <v-col sm="2" style="margin-top: -50px"
                v-if="item.permissions === 0 || item.permissions === 1 || item.permissions === null || item.permissions === true || item.permissions === false">
                <v-checkbox :value="item.permissions" v-model="item.permissions" :label="`Permissions`"
                  color="#0EBDDFF7"></v-checkbox>
              </v-col>

              <!-- view -->
              <v-col sm="2" style="margin-top: -50px"
                v-if="item.view === 0 || item.view === 1 || item.view === null || item.view === true || item.view === false">
                <v-checkbox :value="item.view" v-model="item.view" :label="`View`" color="#0EBDDFF7"></v-checkbox>
              </v-col>

            </v-row>
          </v-box>
        </template>
      </v-data-table>
      <div class="pa-2 d-flex justify-end">
        <span class="pa-2">
          Total Modules
          <span :style="{ 'color': this.$vuetify.theme.themes.light.primary }">{{ paths.length }}</span>
        </span>
        <v-spacer></v-spacer>
        <v-pagination circle v-model="page" :length="pageCount"></v-pagination>
      </div>
    </v-card>
  </v-form>
</template>

<script>
import apiRoutes from "../../utils/routes/apiRoutes";
import routePermissions from "./PathsForPermission";

export default {
  name: "PermssionTable",
  components: {},
  data() {
    return {
      selectedRole: "",
      roles: [],
      paths: [],
      page: 1,
      pageCount: 3,
      itemsPerPage: 10,
      headers: [
        { text: "Modules", value: "modules", sortable: true },
        { text: "Permissions", value: "permissions", sortable: false }
      ]
    };
  },
  methods: {
    getPermissions() {
      this.loading = true;
      axios
        .post(apiRoutes.permissions.getPermission, {
          roleId: this.selectedRole
        })
        .then(res => {
          let permFromDb = [];
          res.data.map(item => {
            let p = {
              modules: item.modules,
              module_path: item.module_path,
              permissions: JSON.parse(item.permissions)
            };
            permFromDb.push(p);
          });

          let result1 = routePermissions; // herdcoded urls
          let result2 = permFromDb; // urls from db

          var props = ["modules", "module_path", "permissions"];

          var result = result1
            .filter(function (o1) {
              return !result2.some(function (o2) {
                return o1.module_path === o2.module_path;
              });
            })
            .map(function (o) {
              return props.reduce(function (newo, name) {
                newo[name] = o[name];
                return newo;
              }, {});
            });

          let finalRes = [...result2, ...result];

          this.paths = finalRes;
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
          console.log(err, "err");
        });
    },
    savePermissions() {
      this.loading = true;
      axios
        .post(apiRoutes.permissions.update, {
          roleId: this.selectedRole,
          paths: this.paths
        })
        .then(res => {
          console.log(res, "res");
        })
        .catch(err => {
          console.log(err, "err");
        });
    },
    getZeroAddedNum(num) {
      return num.toString().padStart(2, "0");
    },
    getRoles() {
      axios
        .get(apiRoutes.roles.getRoles)
        .then(res => {
          let roles = [];
          res?.data?.map(item =>
            roles.push({ text: item.display_name, value: item.id })
          );
          this.roles = roles;
        })
        .catch(err => {
          console.log(err, "err");
        });
    },
    titleCase(string) {
      let str = string;
      let withoutUnderScore = str.replace("_", " ");
      var sentence = withoutUnderScore.toLowerCase().split(" ");
      for (var i = 0; i < sentence.length; i++) {
        sentence[i] = sentence[i][0].toUpperCase() + sentence[i].slice(1);
      }
      return sentence.join(" ");
    }
  },
  mounted() {
    this.loading = false;
    this.getRoles();
    // this.paths = routePermissions;
  }
};
</script>

<style lang='scss'>
.v-data-table-header th span {
  font: 300 14px Gotham;
  font-family: "Gotham Narrow";
  color: #8898aa;
}

.table-users {
  &-srno {
    font: 500 14px/13px Gotham;
    color: #172b4d;
  }

  &-name {
    display: block;
    font: 500 14px/13px Gotham;
    color: #6a158e;
  }

  &-email {
    font: 400 12px/13px Lato;
    color: #172b4d4d;
  }

  &-time {
    display: block;
    font: 400 11px/10px Lato;
    color: #0e0edff7;
  }

  &-days {
    font: 400 10px/15px Lato;
    color: #172b4db3;
  }

  &-status {
    font: 500 14px/13px Gotham;

    &.st-success {
      color: #129b11;
    }

    &.st-error {
      color: #e41b1bf7;
    }
  }

  &-tutor {
    font: 500 13.5px Gotham;
    color: #529b11;
  }
}

.v-btn.v-size--default {
  font-size: 12px;
  text-transform: none;
}
</style>